<template lang="pug">
    .product-item(v-if="content")
        .product-item__bg
        .product-item__popup
            .product-item__popup-button-close(@click="closePopup()")
                SvgIcon.product-item__popup-button-close-icon(name="close" width="20" height="20")
            .product-item__popup-headline {{ content.popup.title }}
            .product-item__popup-list-wr
                ul.product-item__popup-list
                    li.product-item__popup-list-item(v-for="item in content.popup.files")
                        .product-item__popup-list-item-block
                            p.product-item__popup-list-item-block-text {{ item.name }}
                            a.product-item__popup-list-item-block-download(:href="item.file" download target="blank")
                                SvgIcon.product-item__popup-list-item-block-download-icon(name="download" width="28" height="34")
                                .product-item__popup-list-item-block-download-text Скачать
        .page__wr.product-item__wr
            ul.product-item__nav
                li.product-item__nav-item(v-for="(item, index) in content.nav" :key="index" :class="{'product-item__nav-item--active': index == content.nav.length-1}")
                    router-link(:to="item.link") {{ item.name }}
            h2.product-item__headline {{ content.title }}
            .product-item__container
                .product-item__container-left
                    .product-item__container-left-slider
                        .swiper-container
                            .swiper-wrapper
                                .swiper-slide.product-item__container-left-swiper-slide(v-for="(image, index) in content.slider" :key="index")
                                    .product-item__container-left-slider-item
                                        .product-item__container-left-slider-item-layout
                                        .product-item__container-left-slider-item-img-wr
                                            img.product-item__container-left-slider-item-img(:src='image.path' :alt="image.name" v-show='!imgHide')
                        .product-item__container-left-slider-navigation
                            .swiper-button-prev
                                SvgIcon(class='.product-item__container-left-slider-ico' name="arrow-left" width="11" height="19")
                            .product-item__container-left-slider-pagination.swiper-pagination.swiper-pagination-clickable.swiper-pagination-bullets
                            .swiper-button-next
                                SvgIcon(class='.product-item__container-left-slider-ico' name="arrow-right" width="11" height="19")
                    .product-item__container-left-block-button(@click="openPopup()" v-if='content.popup.files.length > 0')
                        .product-item__container-left-block-button-text Скачать каталог
                    form.product-item__container-left-form(v-on:submit.prevent="submit" :class="{'product-item__container-left-form--show': !formSend}")
                        h2.product-item__container-left-form-legend Оставить заявку
                        input.product-item__container-left-form-input(type="text" placeholder="Ваше имя" v-model="name" required)
                        input.product-item__container-left-form-input(type="email" placeholder="E-mail" v-model="email" required)
                        input.product-item__container-left-form-input(type="tel" name="phone" v-model="phone" v-mask="'+7(###)-###-##-##'" placeholder="+7(____)-____-___-___" required)
                        textarea.product-item__container-left-form-textarea(placeholder="Коментарий" v-model="comment" required)
                        button.product-item__container-left-button(type="submit") Отправить
                        .product-item__container-left-form-description
                            p.product-item__container-left-form-description-text Нажимая кнопку «Отправить», я даю согласие
                            p.product-item__container-left-form-description-text на
                                router-link(to="/politika-konfidencial-nosti" target="_blank").product-item__container-left-form-description-text--link  обработку персональных данных
                    .product-item__container-left-form-send(:class="{'product-item__container-left-form-send--show': formSend}")
                        h5.product-item__container-left-form-send-text Форма успешно отправлена!
                        h5.product-item__container-left-form-send-text Скоро мы свяжемся с Вами
                .product-item__container-right
                    h5.product-item__container-right-headline {{ content.subtitle }}
                    ul.product-item__container-right-list
                        li.product-item__container-right-list-item(v-for="(item, index) in content.characteristics" :key="index") {{ item.text }}
                    p.product-item__container-right-description {{ content.placeOfPurchase }}
                        a.product-item__container-right-description-link(:href="content.phone.link") {{ content.phone.title }}
</template>

<script>
    import EventBus from '@/eventBus';
    import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';

    import '@/components/common/productItem/productItem.styl';
    import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';
    import {SliderHelpersVue} from "@/mixins/SliderHelpersVue";
    import {FormHelpersVue} from '@/mixins/FormHelpersVue';
    import 'perfect-scrollbar/css/perfect-scrollbar.css';
    import PerfectScrollbar from 'perfect-scrollbar';
    // import fancyBox from 'vue-fancybox';

    export default {
        name: 'ProductItem',

        mixins: [AjaxHelpersVue, SliderHelpersVue, FormHelpersVue],

        data() {
            return {
                content: null,
                facilities: null,
                imgHide: true,
                objImages: [],
                name: '',
                phone: '',
                email: '',
                comment: '',
                formSend: false,
            }
        },

        components: {
            SvgIcon,
        },

        created() {
            // Загрузка данных для страницы

            EventBus.$on('imgLoaded', (res) => {
                this.imgHide = res;
            });
        },

        beforeRouteEnter(to, from, next) {
            next(vm => {
                // экземпляр компонента доступен как `vm`
                EventBus.$emit('pagePreloaderShow');
                vm.scrollbarCheck();
                setTimeout(() => {
                    EventBus.$emit('setMenuTopActiveClass', to.path);
                    vm.request(to.params.item, to.params.type);
                }, 50);
            })
        },

        beforeRouteUpdate(to, from, next) {
            EventBus.$emit('pagePreloaderShow');
            this.scrollbarCheck();
            setTimeout(() => {
                EventBus.$emit('setMenuTopActiveClass', to.path);
                this.request(to.params.item, to.params.type);
                next();
            }, 50);
        },

        mounted() {
            this.$nextTick(() => {
                // setTimeout(() => {
                //     $().fancybox({
                //         selector : '.product-item__popup'
                //     });
                // }, 200);
                // $('.product-item__popup').fancybox();
            });
        },

        methods: {
            request(product, category) {
                let data = {
                    categoryId: category,
                    productId: product
                };
                this.req('ProductsPage:getProductItem', data, res => {
                    this.content = res.content;
                    if(this.content.status === 'ok') {
                        for(let i = 0; i < this.content.slider.length; i++) {
                            this.objImages = this.objImages.concat({loaded: false, url: this.content.slider[i].path});
                        }
                        EventBus.$emit('pagePreloaderHide');
                        this.$nextTick(() => {
                            this.checkOverflow(this.$router.currentRoute.params);
                            this.scrollInit();
                            this.initThisSlider('.product-item__container-left-slider', 'product-item__container-left-slider');
                            this.checkImgLoading(this.objImages);
                            let src = '/img/background.png';
                            let $img = $( '<img src="' + src + '">' );
                            $img.bind( 'load', function(){
                                $('.product-item__bg' ).css({'background-image': 'url(' + src + ')', 'opacity': '1'} );
                            });
                            if( $img[0].width ){ $img.trigger( 'load' ); }
                        });
                    } else {
                        this.$router.push('/*');
                    }
                });
            },
            submit() {
                let data = {
                    name: this.name,
                    email: this.email,
                    phone: this.phone,
                    comment: this.comment
                };

                this.submitForm('ProductsPage:sendForm', data, res => {
                    this.name  = '';
                    this.email = '';
                    this.phone = '';
                    this.comment = '';
                    if(res.status === 'ok') {
                        this.formSend = true;
                    }
                });

                ym(61363291, 'reachGoal', 'application');
            },

            scrollInit() {
                if($('.product-item__popup-list').length) {
                    let ps = new PerfectScrollbar('.product-item__popup-list-wr', {
                        wheelSpeed: 2,
                        wheelPropagation: true,
                        minScrollbarLength: 20
                    });
                }
            },

            initThisSlider(sliderClass, slideClass, params) {
                let $slider           = $(sliderClass);
                let $sliderNextBtn    = $slider.find('.swiper-button-next');
                let $sliderPrevBtn    = $slider.find('.swiper-button-prev');
                let $sliderPagination = $slider.find('.swiper-pagination');
                let that = this;

                if($slider.find('.swiper-slide-active').length) return;

                let slidesCount = $slider.find('.swiper-slide').length;

                let sliderParams = {};

                let sliderParamsDefault = null;

                sliderParamsDefault = {
                    init: false,
                    centeredSlides: true,
                    speed: 600,
                    spaceBetween: 0,
                    slideDuplicateClass: 'swiper-slide-duplicate',
                    //autoplay: {
                    //  delay: 5000
                    //},
                    slidesPerView: 1,
                    navigation: {
                        nextEl: $sliderNextBtn,
                        prevEl: $sliderPrevBtn
                    },
                    pagination: {
                        el: $sliderPagination,
                        type: 'bullets',
                        clickable: true,
                    },
                    // loop: true, // в цикле не работают события вью из-за клонирования слайдов без событий
                    // simulateTouch: true,
                    observer: true, // если слайдер изначально скрыт
                    observeParents: true, // если слайдер изначально скрыт
                    on: {
                        init: function() {
                            that.slideClasses(sliderClass, slideClass);
                        },

                        transitionStart: function() {
                            that.slideClasses(sliderClass, slideClass);
                        }
                    }
                };

                if(typeof sliderParams !== 'undefined') {
                    sliderParams = Object.assign(sliderParamsDefault, params);
                }

                if(slidesCount <= 1 ) {
                    $.extend(sliderParams, {
                        loop: false,
                        virtualTranslate: true,
                        centeredSlides: false
                    });

                    $sliderNextBtn.hide();
                    $sliderPrevBtn.hide();
                    $sliderPagination.hide();

                    if(params == undefined) {
                        $(sliderClass).addClass(slideClass + '--center');
                    }
                } else {
                    $sliderNextBtn.show();
                    $sliderPrevBtn.show();
                    $sliderPagination.show();
                }

                if($slider.length) {
                    $(sliderClass).removeClass(slideClass + '--center');
                    this.swiper = null;
                    this.swiper = new Swiper($slider.find('.swiper-container'), sliderParams);

                    this.swiper.init();

                    EventBus.$emit('SwiperInit', this.swiper);

                    if(params == undefined) {
                        this.swiper.slideTo(1, 300);
                    }
                }
            },

            openPopup() {
                let elem = $('.product-item__popup');

                $.fancybox.open({
                    src  : elem,
                    type : 'inline',
                    opts : {
                        animationEffect: "zoom-in-out",
                        // afterShow : function( instance, current ) {
                        //     console.info( 'done!' );
                        // }
                        touch: false
                    }
                });

              ym(61363291, 'reachGoal', 'catalog');
            },

            closePopup() {
                $.fancybox.close();
            }
        }
    }
</script>
